module.exports = __webpack_public_path__ + "img/language.2825184f.png";